// extracted by mini-css-extract-plugin
export default {"root":"MessageAuthorPicture_root__g9ZSa","icon":"MessageAuthorPicture_icon__B+5Wm","spinner":"MessageAuthorPicture_spinner__C7NHv"};